<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const sections = [
  {
    label: 'Prayer Talks',
    routeName: 'adminPrayerTalksList',
    pathPrefix: '/admin/prayer-talks',
  },
  {
    label: 'Reading Plans',
    routeName: 'adminReadingPlansList',
    pathPrefix: '/admin/reading-plans',
  },
  {
    label: 'Stories',
    routeName: 'adminStories',
    pathPrefix: '/admin/stories',
  },
  {
    label: 'Expert Commentary',
    routeName: 'adminExpertCommentary',
    pathPrefix: '/admin/expert-commentary',
  },
];

const isSectionActive = (pathPrefix: string) => route.path.startsWith(pathPrefix);

const openRoute = (name: string) => {
  router.push({
    name,
  });
};
</script>

<template>
  <div class="top-bar">
    <span class="top-bar-title">Admin</span>
    <div class="top-bar-sections">
      <button
        v-for="section in sections"
        :key="section.routeName"
        class="section-btn"
        :class="{ active: isSectionActive(section.pathPrefix) }"
        @click="openRoute(section.routeName)"
      >
        {{ section.label }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.top-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
}

.top-bar-title {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  margin-right: 8px;
}

.top-bar-sections {
  display: flex;
  gap: 4px;
}

.section-btn {
  padding: 6px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f5f5f5;
  color: #555;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background-color: #e0e0e0;
  }
}

.section-btn.active {
  background-color: #333;
  color: #fff;
  border-color: #333;

  &:hover {
    background-color: #222;
  }
}
</style>
